import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from "react";
import { translate } from '@haldor/ui';
import { connect } from "react-redux";
import { withRouter, Link } from 'react-router-dom';
import Moment from "moment";
import swal from 'sweetalert2';
import User from '_class/User';
import { getGuardianById, setGuardian, deleteStudentGuardian } from "actions/user";
import { getSchoolGuardians } from "actions/schools";
import { setPageTitle } from "actions/header";
import { getActiveSchool } from 'helpers/localstorage';
import GuardianDetailsForm from '../Forms/GuardianDetailsForm';
import Modal from 'containers/Modals/Modal';
import { Block as ContentBlock, Flex, Skeleton, TooltipMenu, Button, getActiveLanguage } from '@haldor/ui';
import { Spinner, DataList } from 'UI';
import RowItem, { RowCell } from 'UI/Elements/List/RowItem';
import Block, { BlockHeader, BlockContent, BlockWrapper } from "UI/Elements/Block";

var Guardian = /*#__PURE__*/function (_Component) {
  _inherits(Guardian, _Component);

  var _super = _createSuper(Guardian);

  function Guardian(props) {
    var _this;

    _classCallCheck(this, Guardian);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "UNSAFE_componentWillReceiveProps", function (nextProps) {
      var userId = null;

      if (nextProps.match.params.userId != null && _this.props.match.params.userId == undefined) {
        userId = nextProps.match.params.userId;
      }

      if (userId == null && nextProps.match.params.userId != null && _this.props.match.params.userId != null && nextProps.userId != _this.props.match.params.userId) {
        userId = nextProps.match.params.userId;
      }

      if (_this.state.guardian == null && userId != null) {
        _this.props.getGuardianById(userId).then(function () {
          var guardian = _this.props.currentGuardian;

          _this.props.setPageTitle(guardian.firstName + ' ' + (guardian.lastName != null ? guardian.lastName : ''));

          _this.setState({
            loading: false,
            loadingGuardians: false,
            guardian: guardian,
            guardians: null
          });
        });
      }

      if (_this.state.guardians == null && nextProps.match.params.userId == undefined) {
        var school = getActiveSchool(_this.props.currentUser.id);

        _this.props.getSchoolGuardians(school).then(function () {
          _this.props.setPageTitle(_this.props.translate('Guardians'));

          var guardians = _this.props.guardians;

          _this.setState({
            loading: false,
            loadingGuardians: false,
            guardian: null,
            guardians: guardians
          });
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      var userId = null;

      if (_this.props.match.params != null && _this.props.match.params.userId != null) {
        userId = _this.props.match.params.userId;
      }

      if (userId != null) {
        _this.props.getGuardianById(userId).then(function () {
          var guardian = _this.props.currentGuardian;

          _this.props.setPageTitle(guardian.firstName + ' ' + (guardian.lastName != null ? guardian.lastName : ''));

          _this.setState({
            loading: false,
            loadingGuardians: false,
            guardian: guardian
          });
        });
      } else {
        var school = getActiveSchool(_this.props.currentUser.id);

        _this.props.getSchoolGuardians(school).then(function () {
          _this.props.setPageTitle(_this.props.translate('Guardians'));

          var guardians = _this.props.guardians;

          _this.setState({
            loading: false,
            loadingGuardians: false,
            guardians: guardians
          });
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "toggleModal", function () {
      _this.setState({
        modal: !_this.state.modal
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onGuardianUpdate", function (guardian) {
      if (guardian.id != "") {
        _this.props.setGuardian(guardian.id, guardian).then(function () {
          _this.setState({
            guardian: guardian
          });

          _this.toggleModal();
        });
      } else {
        _this.props.getUserGuardianByEmail(guardian.mail).then(function () {
          if (_this.props.guardianByMail == null) {
            _this.props.addUserGuardian(_this.props.user, guardian).then(function () {
              _this.toggleModal();
            });
          }
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onMailChanged", function (email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      if (re.test(String(email).toLowerCase())) {
        _this.props.getUserGuardianByEmail(email).then(function () {
          if (_this.props.guardianByMail != null && _this.props.guardianByMail.mail == email) {
            var guardian = _this.props.guardianByMail;
            guardian.id = "";

            _this.toggleModal();

            _this.toggleModal("guardian", guardian);
          }
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onGuardianDelete", function (guardian) {
      swal.fire({
        title: _this.props.translate('are-you-sure'),
        showCancelButton: true,
        cancelButtonText: _this.props.translate('Cancel'),
        confirmButtonText: _this.props.translate('Delete')
      }).then(function (response) {
        if (response.value != null) {
          _this.props.deleteStudentGuardian(_this.props.user, guardian.id, true).then(function () {
            _this.setState({
              guardian: null
            });

            _this.props.history.push('/guardian');

            _this.toggleModal();
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderGuardian", function (guardian) {
      return /*#__PURE__*/React.createElement(RowItem, {
        key: guardian.id,
        target: "/guardian/".concat(guardian.id)
      }, /*#__PURE__*/React.createElement(RowCell, {
        title: _this.props.translate('name')
      }, guardian.firstName + " " + (guardian.lastName != null ? guardian.lastName : '')), /*#__PURE__*/React.createElement(RowCell, {
        title: _this.props.translate('e-mail')
      }, guardian.mail));
    });

    Moment.locale(getActiveLanguage());
    _this.state = {
      loading: true,
      modal: false,
      loadingGuardians: true,
      guardian: null,
      guardians: null
    };
    return _this;
  }

  _createClass(Guardian, [{
    key: "render",
    value: function render() {
      var _this2 = this,
          _this$props$guardians;

      var translate = this.props.translate;
      var user = new User(this.props.currentUser);
      var triggerButton = /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        style: {
          marginLeft: 0
        }
      }, "⋯");

      if (this.state.loading) {
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
          className: "guardian-card"
        }, /*#__PURE__*/React.createElement(Block, {
          key: "guardian"
        }, /*#__PURE__*/React.createElement(BlockHeader, null), /*#__PURE__*/React.createElement(BlockContent, {
          style: {
            paddingTop: '0px'
          }
        }, /*#__PURE__*/React.createElement(Flex, null, /*#__PURE__*/React.createElement("div", {
          style: {
            flex: 1
          }
        }, /*#__PURE__*/React.createElement("div", {
          style: {
            width: 125
          }
        }, /*#__PURE__*/React.createElement(Skeleton, null))))))));
      }

      return this.state.guardian != null ? /*#__PURE__*/React.createElement("div", {
        className: "guardian-card"
      }, /*#__PURE__*/React.createElement(Modal, {
        onClose: this.toggleModal,
        overridePrompt: true,
        title: this.state.modalType == "user" ? this.props.translate('edit-student') : this.state.currentGuardian != null && this.state.currentGuardian.id == "" ? this.props.translate('create-guardian') : this.props.translate('edit-guardian'),
        isOpen: this.state.modal,
        type: "small"
      }, /*#__PURE__*/React.createElement(GuardianDetailsForm, {
        currentGuardian: this.state.guardian,
        cancelModal: this.toggleModal,
        onModalSave: this.onGuardianUpdate,
        onMailChanged: this.onMailChanged,
        noStudent: true
      })), /*#__PURE__*/React.createElement(ContentBlock, null, user.isAdministrator() && !this.state.guardian.synced ? /*#__PURE__*/React.createElement("div", {
        style: {
          "float": "right"
        }
      }, /*#__PURE__*/React.createElement(TooltipMenu, {
        trigger: triggerButton,
        id: this.state.guardian.id
      }, /*#__PURE__*/React.createElement(TooltipMenu.Item, {
        onClick: function onClick() {
          return _this2.toggleModal("guardian", _this2.state.guardian);
        }
      }, this.props.translate('Edit')), /*#__PURE__*/React.createElement(TooltipMenu.Item, {
        onClick: function onClick() {
          return _this2.onGuardianDelete(_this2.state.guardian);
        }
      }, this.props.translate('Delete')))) : null, /*#__PURE__*/React.createElement("div", {
        style: {
          paddingTop: '0px'
        }
      }, /*#__PURE__*/React.createElement(Flex, null, /*#__PURE__*/React.createElement("div", {
        style: {
          flex: 1
        }
      }, this.state.guardian.phone != null ? /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '.55rem'
        }
      }, /*#__PURE__*/React.createElement("strong", null, translate('phone')), /*#__PURE__*/React.createElement("br", null), this.state.guardian.phone) : null, this.state.guardian.mail != null ? /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '.55rem'
        }
      }, /*#__PURE__*/React.createElement("strong", null, translate('e-mail')), /*#__PURE__*/React.createElement("br", null), this.state.guardian.mail) : null), /*#__PURE__*/React.createElement("div", {
        style: {
          flex: 1
        }
      }, this.state.guardian.street != null && this.state.guardian.postal != null ? /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '.55rem'
        }
      }, /*#__PURE__*/React.createElement("strong", null, translate('address')), /*#__PURE__*/React.createElement("br", null), this.state.guardian.street, /*#__PURE__*/React.createElement("br", null), this.state.guardian.postal, ", ", this.state.guardian.city) : null)))), /*#__PURE__*/React.createElement("div", {
        style: {
          padding: '15px 0px 0px 15px'
        }
      }, /*#__PURE__*/React.createElement(Link, {
        to: "/guardian"
      }, translate('show-all-guardians')))) : /*#__PURE__*/React.createElement("div", {
        className: "overview"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '2rem'
        }
      }, user.isAdministrator() ? /*#__PURE__*/React.createElement(DataList, {
        data: this.state.loadingGuardians ? [] : (_this$props$guardians = this.props.guardians) === null || _this$props$guardians === void 0 ? void 0 : _this$props$guardians.sort(function (a, b) {
          return a.lastName.localeCompare(b.lastName);
        }),
        renderRow: this.renderGuardian,
        emptyData: this.state.loadingGuardians ? function () {
          return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Spinner, {
            center: true
          }));
        } : function () {
          return /*#__PURE__*/React.createElement("div", {
            className: "color--meta text--center weight--bold"
          }, translate('no-results'));
        }
      }) : null));
    }
  }]);

  return Guardian;
}(Component);

function mapStateToProps(state) {
  return {
    languages: state.Languages.languages,
    translate: translate(state.Languages.translations),
    currentUser: state.user.currentUser,
    currentGuardian: state.user.guardian,
    guardians: state.School.guardians
  };
}

export default withRouter(connect(mapStateToProps, {
  setPageTitle: setPageTitle,
  getGuardianById: getGuardianById,
  setGuardian: setGuardian,
  getSchoolGuardians: getSchoolGuardians,
  deleteStudentGuardian: deleteStudentGuardian
})(Guardian));